"use strict";

var _slicedToArray = require("/codebuild/output/src3258055365/src/jag-website/node_modules/@babel/runtime/helpers/slicedToArray.js");
require("core-js/modules/es.object.from-entries.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cloneDeep", {
  enumerable: true,
  get: function get() {
    return cloneDeep;
  }
});
function cloneDeep(value) {
  if (Array.isArray(value)) {
    return value.map(function (child) {
      return cloneDeep(child);
    });
  }
  if (typeof value === "object" && value !== null) {
    return Object.fromEntries(Object.entries(value).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];
      return [k, cloneDeep(v)];
    }));
  }
  return value;
}